var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HelloWorld',{attrs:{"msg":"Spécialites médicales","urlimage":"specialite_medecine.png"}}),_c('specialite',{attrs:{"msg":"Spécialites médicales","urlimage":"logo_01.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }